export const EnumAppType = {
  NOW_SHARE_APP: {
    id: 1016,
  },
};

export const EnumLanguage = {
  VI: 'vi',
  EN: 'en',
};

// 订单类型
export const EnumOrderType = {
  // MOTO: 1,
  SHIP_CUSTOMER: 2,
  // SHIP_MERCHANT: 3,
  SHIP_SHOPEE: 4,
  SHIP_SHOPEE_SPX: 5,
};

// Ship_Customer 的订单状态
export const EnumShipCustomerStatus = {
  INIT: 1,
  ASSIGNING: 2,
  ASSIGNING_TIMEOUT: 3,
  ASSIGNED: 4,
  COMING: 5,
  USER_CANCELED: 6,
  ARRIVED: 7,
  PICKUP: 8,
  DRIVER_CANCELED: 9,
  IN_PROCESS: 10,
  COMPLETED: 11,
  SYSTEM_CANCELED: 12,
  SYSTEM_ASSIGNED: 13,
  RETURN_SUCCESS: 14,
  RETURN_FAILED: 15,
  SCHEDULING: 16,
  RETURNING: 17,
  DELIVERY_PENDING: 18,
  RETURN_TO_HUB: 19,
  RETURNING_TO_HUB: 20,
  DELIVERY_RETRY: 21,
  RECLAIMED: 22,
  PICKUP_FAILED: 23,
};

// Ship_Shopee 的订单状态
export const EnumShipShopeeStatus = {
  INIT: 1,
  ASSIGNING: 2,
  ASSIGNING_TIMEOUT: 3,
  ASSIGNED: 4,
  SHOPEE_CANCELED: 6,
  PICKUP: 8,
  SHIPPER_CANCELED: 9,
  COMPLETED: 11,
  SYSTEM_CANCELED: 12,
  SYSTEM_ASSIGNED: 13,
  SYSTEM_RE_ASSIGNED: 13,
  RETURN_SUCCESS: 14,
  RETURN_FAILED: 15,
  LOST: 16,
  PICKUP_FAILED: 17,
  DELIVERY_PENDING: 18,
  RETURN_TO_HUB: 19,
  RETURNING_TO_HUB: 20,
  DELIVERY_RETRY: 21,
  RECLAIMED: 22,
};

// 在途状态
export const EnumEnrouteStatus = {
  PICKUP: 1,
  DELIVERY: 2,
};

export const ERROR_CODE_BOOKING_CANCEL = 'error_shared_booking_cancelled';

export const ERROR_CODE_BOOKING_EXPIRED = 'error_shared_booking_expired';

export const ERROR_BOOKING_NOT_FOUND = 'error_booking_not_found';

export const ERROR_SHARED_BOOKING_COMPLETED = 'error_shared_booking_completed';

export const LIST_BEFORE_ASSIGNED_SHIP = [
  EnumShipCustomerStatus.INIT,
  EnumShipCustomerStatus.ASSIGNING,
  EnumShipCustomerStatus.ASSIGNING_TIMEOUT,
  EnumShipCustomerStatus.SYSTEM_ASSIGNED,
];
